var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as React from "react";
import axios from "axios";
import Divider from "../divider";
import NewsItem from "./news-item";
import CONSTS from "../../consts";
const SwiperJS = require("react-id-swiper");
const Swiper = SwiperJS.default;
export default class LatestNews extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            collectionThree: {},
            collectionFour: {}
        };
    }
    componentDidMount() {
        this.getCollectionThree();
        this.getCollectionFour();
    }
    getCollectionThree() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(3)`;
            const response = yield axios.get(query);
            this.setState({
                collectionThree: response.data
            });
        });
    }
    getCollectionFour() {
        return __awaiter(this, void 0, void 0, function* () {
            let oDataPath = CONSTS.APIURL;
            let query = `${oDataPath}Collections(4)`;
            const response = yield axios.get(query);
            this.setState({
                collectionFour: response.data
            });
        });
    }
    render() {
        let collectionThree = this.state.collectionThree;
        let collectionFour = this.state.collectionFour;
        return (React.createElement("div", { className: "latest-news" },
            React.createElement(Divider, null, "Discover More"),
            React.createElement("div", { className: "news-highlights" },
                React.createElement(NewsItem, { link: "/Products/Collections/Sponsored", color: "#a83060", header: "", title: "SPONSORED PRODUCTS", active: true, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/sponsoredProducts.jpg`, paidAdvertisement: collectionFour.PaidAdvertisement }),
                React.createElement(NewsItem, { link: "/Products/Collections/3", color: "#00aba9", header: collectionThree.Name, title: collectionThree.Title, active: collectionThree.Active, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/3.jpg`, paidAdvertisement: collectionThree.PaidAdvertisement }),
                React.createElement(NewsItem, { link: "/Products/Collections/4", color: "#630e3f", header: collectionFour.Name, title: collectionFour.Title, active: collectionFour.Active, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/4.jpg`, paidAdvertisement: collectionFour.PaidAdvertisement }),
                React.createElement(NewsItem, { link: "/Home/Events", color: "#df6126", header: "", title: "UPCOMING EVENTS", active: true, imgPath: `${CONSTS.STORAGEURL}/${CONSTS.COLLECTIONCONTAINER}/upcomingEvents.jpg`, paidAdvertisement: false }))));
    }
}
//# sourceMappingURL=latest-news.js.map